import actions from './actions';

const {
  HISTORY_LIST_BEGIN,
  HISTORY_LIST_SUCCESS,
  HISTORY_LIST_ERR,
} = actions;

const initialStateArray = { data: [], loading: false, error: null };

export const historyListReducer = (state = initialStateArray, action) => {
  const { type, data, err } = action;
  switch (type) {
    case HISTORY_LIST_BEGIN:
      return {
        ...initialStateArray,
        loading: true,
      };
    case HISTORY_LIST_SUCCESS:
      return {
        ...initialStateArray,
        data,
        error: null,
        loading: false,
      };
    case HISTORY_LIST_ERR:
      return {
        ...initialStateArray,
        data: null,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
